<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat class="card-header">
        <v-btn icon exact :to="{name: 'organizations'}"><v-icon>clear</v-icon></v-btn>
        <span class="title">Edit Organization</span>
        <v-spacer></v-spacer>
        <v-btn @click="saveItem" depressed dark color="success">Save</v-btn>
      </v-toolbar>
      <v-container grid-list-sm>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-text-field
            v-model="item.name"
            label="Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            :value="formatDateTime(item.timeModified)"
            disabled
            label="Time Updated"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            :value="formatDateTime(item.timeCreated)"
            disabled
            label="Time Created"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'

export default {
  data () {
    return {
      item: {},
      loading: false
    }
  },

  created () {
    this.getItem()
  },

  computed: {
    isNew: function () {
      if (this.$route.params.id === 'new') {
        return true
      }
      return false
    }
  },

  methods: {
    getItem: function () {
      if (this.isNew) return

      this.loading = true
      ApiRequests.organizationGet(this.$route.params.id).then(r => {
        this.item = r.data
        this.loading = false
      })
    },

    saveItem: function () {
      this.loading = true

      if (this.isNew) {
        ApiRequests.organizationCreate(this.item).then(r => {
          this.item = r.data
          this.loading = false
        })
      } else {
        ApiRequests.organizationSave(this.item).then(r => {
          this.item = r.data
          this.loading = false
        })
      }
    }
  }
}
</script>
